import { render, staticRenderFns } from "./FunctionalAssessment.vue?vue&type=template&id=2c3fb59e"
import script from "./FunctionalAssessment.vue?vue&type=script&lang=ts"
export * from "./FunctionalAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3fb59e')) {
      api.createRecord('2c3fb59e', component.options)
    } else {
      api.reload('2c3fb59e', component.options)
    }
    module.hot.accept("./FunctionalAssessment.vue?vue&type=template&id=2c3fb59e", function () {
      api.rerender('2c3fb59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/FunctionalAssessment.vue"
export default component.exports